// import React, { Component } from 'react';
import RangePicker from './ReactDates/RangePicker';
import { ANCHOR_LEFT, ANCHOR_RIGHT } from 'react-dates/lib/constants';
import Dropdown from './Dropdown';
import moment from 'moment';

// import Cookie from '~/js/modules/Cookie';

// import './ReactDates/DateRangePicker.scss';
// import './ReactDates/Dropdown.scss';

const { Component } = window.React;

import {
    countryList,
    resortList,
    sandalsList,
    beachesList
} from './mockup/quickQuoteFallBack';

class QuickQuote extends Component {
    static defaultProps = {
        brand: 'sandals',
        hasCountries: true,
        hasResorts: true,
        anchorDirection: window.innerWidth < 768 ? ANCHOR_LEFT : ANCHOR_RIGHT,
        className: 'qq',
        controlThemeClassName: '',
        noLabels: false,
        quoteButtonText: 'Rates & Availability',
        quoteButtonClassName: 'dsc-quote-btn',
        reference: 'obe',
        eventID: '',
        groupID: '',
        defaultResortCode: '',
        schedulerModeIndex: 1,
        numberOfMonths: window.innerHeight > 991 ? 2 : 1,
        resortDisabled: false,
        allowedResortCodes: []
        // hasCreditLabel: false,
        // hasCreditLabel: 'SAVE $35',
    };

    constructor(props) {
        super(props);

        this.isMobile = window.innerWidth < 768;

        this.DATE_FORMAT = 'MM/DD/YYYY';
        this.bookNowURL = '/book-now/';

        this._onDatesChange = this._onDatesChange.bind(this);
        this._onFocusChange = this._onFocusChange.bind(this);
        this._onInputChange = this._onInputChange.bind(this);
        this._setDefaultValues = this._setDefaultValues.bind(this);

        this.state = {
            startDate: null,
            endDate: null,
            focusedInput: null,

            fields: {
                reference: 'obe',

                // Inputs
                startDate: '',
                endDate: '',
                resortCode: '',
                resortCountry: '',

                // OEE
                nights: '',
                eventID: '',
                groupID: '',
                isMobile: false,
                schedulerModeIndex: ''

                // // Rooms and Suite

                // /bookingengine/?rst_code=seb&room_category=BWV
                // https://obe.sandals.com/?rst_code=seb&room_category=BWV&resortCountry=BS&event=ehOBE.dspHome

                // 'room_category': '', // HSB1B
                // 'resortCountry': '', // JM
                // 'OBE_PARTNER_AGENT_ID': '', // JOSCH2806
                // // rst_code=smb
                // // event=ehOBE.dspHome
            }
        };
    }

    componentDidMount() {
        this._setDefaultValues();
    }

    _setDefaultValues() {
        const { ...fields } = this.state.fields;
        const {
            reference,
            eventID,
            groupID,
            schedulerModeIndex,
            defaultResortCode
        } = this.props;

        if (reference === 'oee') {
            fields.eventID = eventID;
            fields.groupID = groupID;
            fields.schedulerModeIndex = schedulerModeIndex;
        }

        fields.reference = reference;
        fields.resortCode = defaultResortCode;
        fields.isMobile = this.isMobile;

        this.setState({ fields });
    }

    _toQueryParams(object) {
        const keys = Object.keys(object);
        let parameters = '';
        let value;
        let prefix;

        keys.map(key => {
            value = object[key];
            prefix = parameters ? '&' : '?';

            if (value) {
                parameters += prefix + key + '=' + encodeURIComponent(value);
            }
        });

        return parameters;
    }

    _generateURL(fields) {
        return this.bookNowURL + this._toQueryParams(fields);
    }

    // Date Range Picker
    _onDatesChange({ startDate, endDate }) {
        const { ...fields } = this.state.fields;
        const { reference } = this.props;

        fields.startDate =
            startDate && startDate.clone().format(this.DATE_FORMAT);
        fields.endDate = endDate && endDate.clone().format(this.DATE_FORMAT);

        if (reference === 'oee' && startDate && endDate) {
            fields.nights = endDate.diff(startDate, 'days');
        }

        this.setState({
            startDate,
            endDate,
            fields
        });
    }

    _onFocusChange(focusedInput) {
        this.setState({ focusedInput });
    }

    _onInputChange(event) {
        const { name, value } = event.target;

        const { ...fields } = this.state.fields;

        fields[name] = value;

        if (name === 'resortCountry') {
            fields.resortCode = null;
        }

        this.setState({ fields });
    }

    render() {
        const { fields } = this.state;
        const {
            brand,
            resortDisabled,
            defaultResortCode,
            resortsPlaceholder,
            allowedResortCodes
        } = this.props;
        const { resortCountry } = fields;
        let rstList = sandalsList;

        const url = this._generateURL(fields);

        switch (brand) {
            case 'all':
                rstList = resortList;
                break;
            case 'beaches':
                rstList = beachesList;
                break;
            default:
                rstList = sandalsList;
                break;
        }

        const filteredResortList = rstList.filter(resort => {
            if (allowedResortCodes.length) {
                return allowedResortCodes.includes(resort.val);
            }

            return !resortCountry || resort.country === resortCountry;
        });

        return (
            <div className={this.props.className}>
                {this.props.hasCountries && (
                    <div
                        className={`control-wrapper ${
                            this.props.controlThemeClassName
                        }`}
                    >
                        {!this.props.noLabels && (
                            <label htmlFor="countries">COUNTRY:</label>
                        )}

                        <Dropdown
                            id="countries"
                            inputName="resortCountry"
                            defaultOption="Select a Country"
                            // showDefault={ false }
                            defaultValue={this.state.country}
                            changeHandler={this._onInputChange}
                            options={countryList}
                        />
                    </div>
                )}

                {this.props.hasResorts && (
                    <div
                        className={`control-wrapper ${
                            this.props.controlThemeClassName
                        }`}
                    >
                        {!this.props.noLabels && (
                            <label htmlFor="resorts">RESORT:</label>
                        )}

                        <Dropdown
                            id="resorts"
                            wrapperClassName={resortDisabled ? 'disabled' : ''}
                            inputName="resortCode"
                            defaultOption={
                                resortsPlaceholder || 'Select a Resort'
                            }
                            // showDefault={ false }
                            defaultValue={defaultResortCode}
                            changeHandler={this._onInputChange}
                            options={filteredResortList}
                            disabled={resortDisabled}
                        />
                    </div>
                )}

                <RangePicker
                    startDateId="startDate"
                    endDateId="endDate"
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    focusedInput={this.state.focusedInput}
                    onDatesChange={this._onDatesChange}
                    onFocusChange={this._onFocusChange}
                    startDateLabelText="CHECK-IN"
                    endDateLabelText="CHECK-OUT"
                    startDatePlaceholderText="Check-In"
                    endDatePlaceholderText="Check-Out"
                    anchorDirection={this.props.anchorDirection}
                    noLabels={this.props.noLabels}
                    numberOfMonths={
                        window.innerWidth > 991 ? this.props.numberOfMonths : 1
                    }
                    orientation={this.props.orientation}
                />

                <a className={this.props.quoteButtonClassName} href={url}>
                    {this.props.quoteButtonText}
                </a>
            </div>
        );
    }
}

export default QuickQuote;
